import React from 'react';
import classNames from 'classnames';

const barSegments = [
  { color: '#4F9C7E', penalty: 50, prompt: 'Minimal', promptColor: '#fff' },
  { color: '#CEE244', penalty: 50, prompt: 'Minor' },
  { color: '#FAF149', penalty: 70, prompt: 'Noticeable' },
  { color: '#EBBF27', penalty: 80, prompt: 'Bad' },
  { color: '#D14228', penalty: 90, prompt: 'Severe', promptColor: '#fff' },
];

const RatingScale = (props) => {
  const { selectedAnswer = {} } = props.qualityCheckRecord;
  return (
    <div className="condition-rating-scale top30">
      <div className="bar-chart-title text-bold bot30">Rate the severity of flaws</div>
      <div className="bar-chart">
        {barSegments.map((segment, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                if (segment.prompt == selectedAnswer.AnswerText) {
                  /* if the same answer is selected */
                  return;
                }

                let penaltyToApply = segment.penalty;

                if (selectedAnswer.AnswerText && segment.prompt !== selectedAnswer.AnswerText) {
                  /* if some answer was already selected, we increase total by this Penalty value back */
                  penaltyToApply = penaltyToApply - selectedAnswer.Penalty;
                }

                props.qualityCheckAnswerHandler({
                  dataToUpdate: {
                    selectedAnswer: {
                      AnswerText: segment.prompt,
                      Penalty: segment.penalty,
                    },
                  },
                  penaltyToApply,
                  keepThisQualityCheck: true,
                });
              }}
              className={classNames('bar-segment', {
                selected: selectedAnswer.AnswerText == segment.prompt,
              })}
              style={{ background: `${segment.color}`, width: `${100 / barSegments.length}%` }}
            >
              {!selectedAnswer.AnswerText && index == 2 && (
                <div  className="prompt-wrapper --visible-box">
                  <div style={{ backgroundColor: '#E3E3E3' }} className="prompt-box">
                    <div>Click on Scale</div>
                  </div>
                  <div style={{ borderBottomColor: '#E3E3E3' }} className="triangle"></div>
                </div>
              )}
              <div style={segment.promptWrapper} className="prompt-wrapper">
                <div style={{ backgroundColor: segment.color }} className="prompt-box">
                  <div style={{ color: segment.promptColor || 'black' }}>{segment.prompt}</div>
                </div>
                <div style={{ borderBottomColor: segment.color }} className="triangle"></div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="rating-scale-label-box">
        <div>Barely noticeable and/or hard to spot</div>
        <div>Noticeable when standing next to item</div>
        <div>Obvious from across room, or makes item harder to use</div>
      </div>
    </div>
  );
};

export default RatingScale;
